var searchApp = new Vue({
  el: '#news_filter',
  data: {
    AllBuildingBlockItems: AllBuildingBlocks,
    AllDocTypes: AllDocTypes,
    AllNewsTypes: AllNewsTypes,
    AllRegions: AllRegions,


    slider: null,
    mySliderOptions: {
      slidesPerView: 'auto',
      // Navigation arrows
      navigation: {
        nextEl: '.latestSwiper-button-next.news',
        prevEl: '.latestSwiper-button-prev.news',
      },
    },
    currentSlide: 1,
    view: 'list',
    selectedBlock: [],
    BlockIsPrefiltered: false,
    selectedTypes: [],
    TypesIsPrefiltered: false,
    selectedCountries: [],
    CountriesIsPrefiltered: false,
    selectedRegion: [],
    RegionIsPrefiltered: false,

    countrySearch: '',
    allCountires: newsCountriesCollection,

    loading: true,
    postsPerPage: 4,
    currentPage: 1,
    
    allItems: [],
    callTimeout: null,
    callDelay: 500,

    postCountOptions: [4, 8, 12],
    postCountAll: true,

    locale: loc,
  },
  created() {
    this.clearFilterArrays()
  },
  methods: {
    deleteFilterItem (selectedArray, itemIndex) {
      if (this[selectedArray] && this[selectedArray][itemIndex]) {
        this[selectedArray].splice(itemIndex, 1)
      }
    },
    getFeed () {
      this.loading = true
      let apiString = `/events_news/feed.json?`

      if (this.locale && this.locale != 'en' ) {
        apiString = `/${ this.locale }/events_news/feed.json?`
      }

      if (this.selectedBlock.length > 0) {
        apiString += `block=${this.selectedBlock.join('|')}&`
      }
      if (this.selectedTypes.length > 0) {
        apiString += `news=${this.selectedTypes.join('|')}&`
      }
      if (this.selectedCountries.length > 0) {
        apiString += `country=${this.selectedCountries.join('|')}&`
      }
      if (this.selectedRegion.length > 0) {
        apiString += `region=${this.selectedRegion.join('|')}`
      }

      axios.get(apiString).then(response => {
          this.currentPage = 1
          this.allItems = response.data.items
          this.loading = false

          this.resetToolTip()
        });
    },
    resetToolTip() {
      let self = this

      setTimeout(() => {
        $('.news-card__icon').tooltip()
      }, 1000);

      setTimeout(() => {
        this.slider = new window.Swiper(this.$refs.vueResourceSwiper, this.mySliderOptions)
        this.slider.init()
        this.slider.on('slideChange', function () {
          self.currentSlide = self.slider.activeIndex + 1
        });
      }, 1500);

      },
    getNewItems () {
      this.loading = true
      if (this.callTimeout !== null) {
        clearTimeout(this.callTimeout)
        this.callTimeout = null
      }

      this.callTimeout = setTimeout(() => {
        this.getFeed()
      }, this.callDelay);
    },
    prevPage () {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    nextPage () {
      if (this.currentPage < this.pageCount) {
        this.currentPage++
      }
    },
    clearFilterArrays() {
      this.selectedBlock = []
      this.selectedTypes = []
      this.selectedCountries = []
      this.selectedRegion = []

      this.BlockIsPrefiltered = false
      this.TypesIsPrefiltered = false
      this.CountriesIsPrefiltered = false
      this.RegionIsPrefiltered = false

      try {
        if (preFilterBlock !== undefined && preFilterBlock.length > 0) {
          this.selectedBlock = preFilterBlock
          this.BlockIsPrefiltered = true
        }
      } catch (error) {}

      try {
        if (preFilterType !== undefined && preFilterType.length > 0) {
          this.selectedTypes = preFilterType
          this.TypesIsPrefiltered = true
        }
      } catch (error) {}

      try {
        if (preFilterCountries !== undefined && preFilterCountries.length > 0) {
          this.selectedCountries = preFilterCountries
          this.CountriesIsPrefiltered = true
        }
      } catch (error) {}

      try {
        if (preFilterRegion !== undefined && preFilterRegion.length > 0) {
          this.selectedRegion = preFilterRegion
          this.RegionIsPrefiltered = true
        }
      } catch (error) {}
    },
    eventDateFormat(start, end) {
      const startJsDate = new Date (start)
      const endJsDate = new Date (end)
      console.log(start)
      // let dateString = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(startJsDate)
      
      // if (end) {
      //   dateString += ` - ${new Intl.DateTimeFormat('en', { day: '2-digit' }).format(endJsDate)} ${new Intl.DateTimeFormat('en', { month: 'long' }).format(endJsDate)} ${new Intl.DateTimeFormat('en', { year: 'numeric' }).format(endJsDate)}`
      // } else {
      //   dateString += ` ${new Intl.DateTimeFormat('en', { month: 'long' }).format(startJsDate)} ${new Intl.DateTimeFormat('en', { year: 'numeric' }).format(startJsDate)}`
      // }

      // return dateString
      return null
    },
  },
  computed: {
    filterCount () {
      let totalCount = 0
      if (!this.BlockIsPrefiltered) {
        totalCount += this.selectedBlock.length
      } 
      if (!this.TypesIsPrefiltered) {
        totalCount += this.selectedTypes.length
      } 
      if (!this.CountriesIsPrefiltered) {
        totalCount += this.selectedCountries.length
      } 
      if (!this.RegionIsPrefiltered) {
        totalCount += this.selectedRegion.length
      } 

      return totalCount
    },
    filteredCountries () {
      const search = this.countrySearch;

      let allItmes = []

      if (search.length > 0) {
        allItmes =  this.allCountires.filter(obj => Object.values(obj).some(val => val.includes(search)));
        
      } else {
        allItmes =  this.allCountires

      }

      return allItmes.sort((a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0));

    },
    pageCount () {
      return Math.ceil(this.allItems.length / this.postsPerPage)
    },
    displayGroup () {
      return this.allItems.slice((this.currentPage - 1) * this.postsPerPage, this.currentPage * this.postsPerPage)
      // return this.filteredResource.slice((this.currentPage - 1) * this.postsPerPage, this.currentPage * this.postsPerPage)
    },
    type_text () {
      if (this.selectedTypes.length > 0) {
        return `Type (${this.selectedTypes.length})`
      }


      return 'Type'
    },
    formatedSelectedBlock () {
      return this.AllBuildingBlockItems.filter(x => this.selectedBlock.includes(x.slug))
    },
    // formatedSelectedDocType () {
    //   return this.AllDocTypes.filter(x => this.selectedTypes.includes(x.slug))
    // },
    formatedSelectedNewsType () {
      return this.AllNewsTypes.filter(x => this.selectedTypes.includes(x.slug))
    },
    formatedSelectedCountry () {
      return this.allCountires.filter(x => this.selectedCountries.includes(x.slug))
    },
    formatedSelectedRegion () {
      return this.AllRegions.filter(x => this.selectedRegion.includes(x.slug))
    },
  },
  watch: {
    selectedBlock () {
      this.getNewItems()
    },
    selectedTypes () {
      this.getNewItems()
    },
    selectedCountries () {
      this.getNewItems()
    },
    selectedRegion () {
      this.getNewItems()
    },
  },
})